import React, { Component } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import "../style/about.scss";
import ship from "../image/ship.webp";

class Ship extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <React.Fragment>
        <HeaderBar {...this.props} />
        <div className="about-page">
          <div className="about-contain">
            <div className="title"></div>
            <div className="about-tent">
              <div className="left">
                <h1>When will I receive my order?</h1>
              </div>
              <div className="right">
                <p>
                  Shipping times are set by the individual seller and are
                  specified at the bottom of each listing. This is the period
                  within which the seller will post your item. Actual delivery
                  times may vary depending on the method of posting, carrier,
                  etc. For further information about shipping, please contact
                  your seller directly.
                </p>
                <p>
                  Contacting the seller: If you are a registered user, you can
                  use the 'contact the seller' link on the item or profile page.
                  Registered and guest buyers can find the seller's direct email
                  address in the 'thank you for your order' email. Remember that
                  this email is sent from robot@folksy.com but do not reply to
                  this email address - you will need to use the seller's email
                  address, which you will find in the body of the email.
                </p>
                <p>
                  When your item has been posted your seller should update the
                  shipping status of the order, and you will receive an
                  automated email telling you it’s on its way. If you are a
                  registered Folksy user, you can also check the shipping status
                  in your dashboard area (Select 'Your Account' from the
                  dropdown menu underneath your username at the top of the
                  screen and then click on “Your purchases”).
                </p>
                <p>
                  <b>Missing orders</b>
                </p>
                <p>
                  If you haven’t received your item after a few days please
                  contact the seller (please allow longer for international
                  orders). If you do not hear from the seller within 7 days,
                  please contact Folksy admin via the Helpdesk and we can try to
                  contact the seller for you.
                </p>
                <p>
                  <b>Refunds</b>
                </p>
                <p>
                  In the rare event of a shop not delivering the goods, we
                  recommend that you cancel the order and request a refund from
                  the seller. If the seller is unresponsive or non-compliant,
                  you should claim for a refund via Paypal or your bank if you
                  paid by cars (ask them about Chargeback).{" "}
                </p>
                <p>
                  For more information about PayPal refunds, please see the
                  Paypal help page on Claims and disputes. Please note that
                  disputes can only be opened within 180 days of the date of
                  payment.{" "}
                </p>
                <p>Please make sure you report the seller to Folksy too, so we can take action.</p>
              </div>
            </div>
          </div>
        </div>
        <FooterBar {...this.props} />
      </React.Fragment>
    );
  }
}

export default Ship;
